import { NewsArticle } from '../page';

interface NewsHeroProps {
  news: NewsArticle;
}

export default function NewsHero({ news }: NewsHeroProps) {
  const dateStr = news.published_at
    ? new Date(news.published_at).toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric' })
    : '';

  return (
    <section className="pt-20 lg:pt-24">
      <div className="w-full h-56 sm:h-72 md:h-96 lg:h-[480px] relative overflow-hidden">
        {news.cover_image ? (
          <img
            src={news.cover_image}
            alt={news.title}
            className="w-full h-full object-cover object-top"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-teal-800 to-teal-600"></div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 lg:p-14">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-wrap items-center gap-2 mb-3 md:mb-4">
              {news.pinned && (
                <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-red-500 text-white text-xs font-semibold rounded-full">
                  <i className="ri-pushpin-fill text-xs"></i>置顶
                </span>
              )}
              {news.category && (
                <span className="inline-block px-2.5 py-1 bg-teal-500/90 text-white text-xs font-semibold rounded-full">
                  {news.category}
                </span>
              )}
              {(news.tags ?? []).map((tag) => (
                <span key={tag} className="inline-block px-2.5 py-1 bg-white/20 text-white text-xs rounded-full">
                  #{tag}
                </span>
              ))}
            </div>
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-snug">
              {news.title}
            </h1>
            {dateStr && (
              <p className="text-white/70 text-sm mt-3">{dateStr}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
